<template>
  <div class="container app-container">
    <el-form :inline="true" ref="search" :model="search" class="demo-form-inline">
      <el-form-item prop="hospital_name">
        <el-input v-model="search.hospital_name" placeholder="请输入医院名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchData">查询</el-button>
        <el-button @click="resetForm('search')">重置</el-button>
        <el-button type="primary" @click="handleInsertHospital">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.6)"
      max-height="600"
      stripe
    >
      <el-table-column
        type="index"
        label="序号"
        width="50">
        <template slot-scope="{$index}"> {{ $index + ((page_number - 1) * page_size) + 1 }}</template>
      </el-table-column>
      <el-table-column prop="hospital_name" label="医院名称" align="center" />
      <el-table-column prop="created_at" label="创建信息" align="center">
        <template slot-scope="{ row: { created_at } }">
          {{ created_at }}
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="修改信息" align="center">
        <template slot-scope="{ row: { updated_at } }">
          {{ updated_at }}
        </template>
      </el-table-column>
      <el-table-column prop="used_at" label="状态" align="center">
        <template slot-scope="{ row: { status }}">
          {{ status ? '已上架' : '已下架' }}
        </template>
      </el-table-column>
      <el-table-column prop="bind_user" label="绑定微信公众号" align="center">
        <template slot-scope="{ row }">
          <div class="wx-total" style="display: flex; align-items: center; justify-content: center">
            <div class="wx-avatar" style="margin-right: 10px; min-height: 60px">
              <el-image
                style="width: 60px; height: 60px; font-size: 0;"
                :src="row.nid ? row.avatar : ''"
                fit="cover">
                <div slot="error" class="image-slot" style="width: 60px; height: 60px; line-height: 60px; background: #F2F6FC; font-size: 10px; text-align: center; cursor: pointer" @click="getList">
                  点击刷新
                </div>
              </el-image>
              <div v-if="row.nid" class="wx-nickname" style="font-size: 12px">
                {{ row.username }}
              </div>
            </div>
            <el-popover
              placement="right"
              width="200"
              trigger="click"
              @show="handleShow(row)"
              @hide="handleHide(row)"
            >
              <div v-loading="qrCodeLoading" class="url-container" style="width: 200px; min-height: 200px">
                <template v-if="qrCodeUrl">
                  <img @click="handleShow(row)" :src="qrCodeUrl" style="width: 200px;height: 200px; cursor: pointer">
                </template>
                <div style="text-align: center; margin-top: -4px; cursor: pointer" @click="handleShow(row)">点击刷新
                </div>
              </div>
              <el-link style="margin-top: -7px;" slot="reference">绑定</el-link>
            </el-popover>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="operation" label="状态" align="center">
        <template slot-scope="{ row: { status, id }, row}">
          <el-link style="margin-right: 10px" v-if="status" @click="handleDownStatus(id)">下架</el-link>
          <el-link style="margin-right: 10px" v-else @click="handleUpStatus(id)">上架</el-link>
          <el-link @click="handleEditHospital(row)">修改</el-link>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page_size"
        :current-page="page_number"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <EditHospital ref="editHospital" @update="getList" />
<!--    <vue-qrcode-->
<!--      :value="qrCodeUrl"-->
<!--      @change="(base64) => (dataUrl = base64)"-->
<!--      :color="{ dark: '#000000ff', light: '#ffffffff' }"-->
<!--      :type="'image/png'"-->
<!--    />-->
  </div>
</template>

<script>
import { fetchHospitalManageList, editHospital, getOrderNoticeUrl } from '@/api'
import { formatDate } from 'element-ui/lib/utils/date-util'
import EditHospital from './components/EditHospital'
import VueQrcode from 'vue-qrcode'

export default {
  name: 'OrdersManage',
  components: { VueQrcode, EditHospital },
  data() {
    return {
      search: {
        hospital_name: ''
      },
      tableLoading: false,
      qrCodeLoading: true,
      page_size: 10,
      page_number: 1,
      dataUrl: null,
      qrCodeUrl: null,
      total: 0,
      tableData: []
    }
  },
  filters: {
    formatDate
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getList()
    },
    handleShow(row) {
      this.qrCodeLoading = true
      getOrderNoticeUrl({
        type: row.id
      }).then(res => {
        if (res.status) {
          console.log(res.data)
          this.qrCodeUrl = res.data
          this.qrCodeLoading = false
        } else {
          this.$message({
            type: 'warning',
            message: res.msg
          })
        }
      })
    },
    handleHide(row) {
      this.qrCodeUrl = null
      // this.qrCodeLoading = false
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.page_number = 1
      this.getList()
    },
    handleEditHospital(row) {
      this.$refs.editHospital.handleOpen(row)
    },
    handleInsertHospital() {
      this.$refs.editHospital.handleOpen()
    },
    handleDownStatus(id) {
      this.$confirm(`确定下架该医院吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          editHospital({
            id,
            status: 0
          }).then(res => {
            if (res.status) {
              this.$message({
                type: 'success',
                message: '下架成功!'
              })
              this.getList()
            } else {
              this.$message({
                type: 'warning',
                message: res.msg
              })
            }
          })
        })
        .catch(() => {
          console.log('取消删除')
        })
    },
    handleUpStatus(id) {
      this.$confirm(`确定上架该医院吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          editHospital({
            id,
            status: 1
          }).then(res => {
            if (res.status) {
              this.$message({
                type: 'success',
                message: '上架成功!'
              })
              this.getList()
            } else {
              this.$message({
                type: 'warning',
                message: res.msg
              })
            }
          })
        })
        .catch(() => {
          console.log('取消删除')
        })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.page_size = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.page_number = val
      this.getList()
    },
    searchData() {
      this.page_number = 1
      this.getList()
    },
    getList() {
      this.tableLoading = true
      const { page_size, page_number, search } = this
      const { ...searchInfo } = search
      const params = {
        page_size: page_size,
        page_number: page_number,
        ...searchInfo
      }
      this.tableLoading = true
      fetchHospitalManageList(params)
        .then(res => {
          if (res.status) {
            this.tableData = res.data.list
            this.total = res.data.total
          } else {
            this.tableData = []
          }
        })
        .finally(() => {
          this.tableLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;

  .imgbox {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .litimg {
      width: 30px;
      height: 30px;
      margin: 3px;
      object-fit: cover;
      cursor: zoom-in;
    }
  }

  .picture {
    width: 100%;
  }

  .block {
    text-align: center;
  }

  .el-pagination {
    margin-top: 20px;
  }

  .total {
    padding: 0 6% 15px;
    color: #26A4B2;
    text-align: right;
    font-weight: bold;
  }
}
</style>
